import React, { useEffect, useState } from 'react'
import DeviceId from 'utils/detectDevice'
import { domainName } from 'utils/parseDomain'
import { appTitle, appBlockHeading } from 'utils/displayText'
import 'styles/downloadAppLinks.scss'

function DownloadAppLinks(props) {
  const [utmMedium, setUtmMedium] = useState('desktop')

  useEffect(() => {
    const platform = DeviceId.isDesktop() ? 'desktop' : 'mobile'
    setUtmMedium(platform)
  }, [])

  const title = appTitle(props.altTitlePrefix)

  return (
    <div className="dwdAppWrapper">
      <div className="container">
        <div className="row">
          <div className="col-sm-6">
            <h3 className="dwdAppHeading">{appBlockHeading()}</h3>
          </div>
          <div className="col-md-6 appLinkWraper">
            <a
              href={`${
                props.androidAppStore
              }&referrer=utm_source=${domainName}&utm_medium=${utmMedium}&utm_campaign=android-app-homepage`}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="playStore"
              title={title}
            >
              <img
                src="https://img2.shaadi.com/assests/2016/images/playstore-v2.png"
                width="104"
                height="31"
                alt={`Android app to find ${props.altTitlePrefix} matches`}
                title={title}
              />
            </a>
            <a
              href={props.iphoneAppStore}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="ituneStore"
              title={title}
            >
              <img
                src="https://img2.shaadi.com/assests/2016/images/appstore-v2.png"
                width="104"
                height="31"
                alt={`iOS app to find ${props.altTitlePrefix} matches`}
                title={title}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DownloadAppLinks
